module.exports = __webpack_public_path__ + "img/index.4f1b0856.png";